import { SubdirectoryHeadLessArrowRightIcon } from '@modules/common/components/SubdirectoryHeadLessArrowRightIcon';
import { SelectButton } from '@modules/queryBuilder/components/SelectButton';
import { upsertQueryFilterNode } from '@modules/queryBuilder/helpers';
import { QueryBuilderActionType } from '@modules/queryBuilder/store/queryBuilderActionType';
import { useQueryBuilderStore } from '@modules/queryBuilder/store/useQueryBuilderStore';
import { MenuItem, MenuList } from '@mui/material';
import { NormalisedFilterGroup } from 'v2/querybuilder/types/querystore';

interface QueryFilterConjunctionSelectButtonProps {
  filter: NormalisedFilterGroup;
}

export function QueryFilterConjunctionSelectButton({
  filter,
}: QueryFilterConjunctionSelectButtonProps) {
  const dispatch = useQueryBuilderStore(({ dispatch }) => dispatch);
  const nodes = useQueryBuilderStore(({ query }) => query.nodes);

  const onConjunctionChange = (
    newConjunction: NormalisedFilterGroup['conjunction'],
  ) => {
    if (filter.conjunction === newConjunction) {
      return;
    }

    const updatedNodes = upsertQueryFilterNode({
      node: { ...filter, conjunction: newConjunction },
      nodesByID: nodes,
      parentID: filter.parent,
    });

    dispatch({
      type: QueryBuilderActionType.SET_QUERY,
      payload: {
        nodes: updatedNodes,
      },
    });
  };

  return (
    <>
      <SubdirectoryHeadLessArrowRightIcon />
      <SelectButton
        shouldShowTooltip={false}
        label={filter.conjunction ?? ''}
        renderDropDownComponent={({ onClose }) => (
          <MenuList
            dense
            autoFocusItem
            onKeyDown={(event) => {
              if (event.key === 'Tab') {
                event.preventDefault();
                onClose();
              }
            }}
          >
            <MenuItem
              key="OR"
              value="OR"
              autoFocus={'OR' === filter.conjunction}
              onClick={() => {
                onConjunctionChange('OR');
                onClose();
              }}
            >
              OR
            </MenuItem>
            <MenuItem
              key="AND"
              value="AND"
              autoFocus={'AND' === filter.conjunction}
              onClick={() => {
                onConjunctionChange('AND');
                onClose();
              }}
            >
              AND
            </MenuItem>
          </MenuList>
        )}
      />
    </>
  );
}
